export const categoryArticles = [
  {
    slug: 'dianjing-saishi-jijin',
    title: '电竞盛宴：全球顶级赛事精彩回顾与深度解析',
    excerpt: '深入剖析2026年度最受瞩目的电竞赛事，从战术布局到选手表现，带您领略电子竞技的无限魅力。',
    content: `
      <p>电子竞技作为新兴的体育竞技项目，近年来在全球范围内取得了爆发式增长。2026年，多项顶级电竞赛事的举办，不仅吸引了海量观众的目光，更推动了整个产业的蓬勃发展。</p>
      <h2>全球电竞赛事格局</h2>
      <p>从《英雄联盟》全球总决赛到《DOTA2》国际邀请赛，从《CS2》Major锦标赛到《王者荣耀》世界冠军杯，各大主流电竞项目的顶级赛事交替上演，为全球电竞爱好者奉上了一场又一场精彩绝伦的视觉盛宴。</p>
      <p>太阳娱乐平台持续关注全球电竞赛事动态，为用户提供最新的赛事资讯、专业分析和独家解读。我们的专业团队深入赛事一线，为您带来最真实、最全面的赛事报道。</p>
      <h2>中国电竞力量崛起</h2>
      <p>值得骄傲的是，中国电竞队伍在国际赛场上的表现愈发出色。在2026年的多项国际赛事中，中国战队屡创佳绩，展现了中国电竞的强劲实力和无限潜力。太阳娱乐作为国内领先的娱乐平台，始终致力于推动中国电竞事业的发展，为电竞爱好者提供优质的观赛体验和交流平台。</p>
      <h2>赛事数据分析</h2>
      <p>根据权威数据统计，2026年全球电竞赛事总观看时长突破150亿小时，同比增长23%。其中移动电竞占比持续攀升，已达到总观看量的45%。这一数据充分说明了电竞产业巨大的市场潜力和发展空间。</p>
      <p>太阳娱乐紧跟行业趋势，不断优化平台功能，为用户提供高清流畅的赛事直播、实时数据统计和专业解说服务，让每一位电竞爱好者都能享受到极致的观赛体验。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20dramatic%20stage%20lighting%20and%20large%20LED%20screens%20displaying%20game%20action%2C%20packed%20stadium%20atmosphere%2C%20cyberpunk%20aesthetic%20with%20warm%20golden%20accents%2C%20cinematic%20wide%20shot%20with%20atmospheric%20fog%20and%20dynamic%20color%20gradients&width=800&height=450&seq=dianjing-saishi&orientation=landscape',
    category: 'dianjing',
    date: '2026-08-08',
    author: '太阳娱乐编辑部',
    readTime: '8分钟',
    views: 12850,
    tags: ['电竞', '赛事', '游戏'],
  },
  {
    slug: 'tougao-yule-zixun-redian',
    title: '娱乐资讯速递：明星动态、影视热点一网打尽',
    excerpt: '追踪娱乐圈最新动态，汇总热门影视资讯，太阳娱乐为您带来最全面、最及时的娱乐资讯报道。',
    content: `
      <p>娱乐圈从来不缺热点话题。从新片上映到明星动态，从综艺节目到音乐盛典，每一天都有新鲜事发生。太阳娱乐资讯频道为您7×24小时不间断追踪娱乐圈的最新动态。</p>
      <h2>影视热点追踪</h2>
      <p>2026年暑期档竞争激烈，多部国产大片和进口巨制轮番上映。据票房统计数据显示，今年暑期档总票房已突破200亿元，创历史新高。其中多部口碑佳作凭借精良的制作和动人的故事赢得了观众的一致好评。</p>
      <p>太阳娱乐为您整理了最值得关注的影视作品榜单，从剧情片到动作片，从喜剧到科幻，各类题材应有尽有。无论您偏爱哪种类型，都能在太阳娱乐找到心仪的观影推荐。</p>
      <h2>明星动态速递</h2>
      <p>娱乐圈的明星们总是走在时尚和话题的前沿。从红毯造型到日常穿搭，从新作品发布到公益活动参与，太阳娱乐为您全方位呈现明星们的最新动态。</p>
      <p>近期多位一线明星宣布了新作品的拍摄计划，引发了粉丝们的热烈讨论。太阳娱乐将持续关注这些项目的进展，为您带来第一手资讯。</p>
      <h2>综艺节目盘点</h2>
      <p>综艺节目方面，多档新季节目陆续开播，涵盖了音乐竞演、户外真人秀、脱口秀等多种类型。这些节目不仅为观众提供了丰富的娱乐选择，也为艺人提供了展示自我的舞台。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20entertainment%20news%20studio%20with%20elegant%20warm%20lighting%2C%20multiple%20display%20screens%20showing%20celebrity%20content%2C%20modern%20broadcast%20desk%20with%20gold%20accents%2C%20sophisticated%20media%20environment%2C%20professional%20atmosphere%20with%20soft%20ambient%20glow&width=800&height=450&seq=yule-zixun&orientation=landscape',
    category: 'yule',
    date: '2026-08-07',
    author: '太阳娱乐编辑部',
    readTime: '6分钟',
    views: 9620,
    tags: ['娱乐', '明星', '影视'],
  },
  {
    slug: 'tiyu-saishi-lanqiu-zuqiu',
    title: '体育赛事速报：NBA季后赛与五大联赛精彩不断',
    excerpt: '聚焦全球顶级体育赛事，太阳娱乐为您带来NBA、英超、西甲等赛事的最新战报与深度分析。',
    content: `
      <p>体育赛事的魅力在于其不可预测性和激烈的竞技对抗。无论是篮球场上的精彩扣篮，还是绿茵场上的巧妙配合，每一场比赛都牵动着无数球迷的心。</p>
      <h2>NBA赛场风云</h2>
      <p>NBA季后赛战况激烈，多支传统强队与新兴势力之间的较量令人目不暇接。本赛季多支球队展现出了令人惊艳的竞技状态，精彩的个人表现和团队配合层出不穷。</p>
      <p>太阳娱乐体育频道为您提供NBA比赛的实时数据更新、赛后分析和球星专访，让您不错过任何一个精彩瞬间。</p>
      <h2>欧洲五大联赛</h2>
      <p>英超、西甲、意甲、德甲和法甲的新赛季即将拉开帷幕。各支球队在转会市场上的动作频频，新援加盟和战术调整让新赛季充满了悬念和看点。</p>
      <p>太阳娱乐将全程跟踪五大联赛的赛程进展，为您带来最全面的赛事报道和专业解读。</p>
      <h2>中国体育发展</h2>
      <p>中国体育事业蓬勃发展，在多个项目上取得了显著进步。无论是传统优势项目还是新兴体育项目，中国运动员都在国际赛场上展现出了顽强拼搏的精神和卓越的竞技水平。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20with%20dramatic%20lighting%2C%20basketball%20court%20and%20soccer%20field%20split%20composition%2C%20energetic%20atmosphere%20with%20crowd%20cheering%2C%20professional%20sports%20photography%20style%20with%20motion%20blur%20and%20warm%20golden%20highlights&width=800&height=450&seq=tiyu-saishi&orientation=landscape',
    category: 'tiyu',
    date: '2026-08-05',
    author: '太阳娱乐体育部',
    readTime: '7分钟',
    views: 11230,
    tags: ['体育', 'NBA', '足球'],
  },
  {
    slug: 'xian-shang-youxi-tuijian',
    title: '2026最受欢迎线上游戏推荐：精品游戏一网打尽',
    excerpt: '盘点2026年度最受玩家欢迎的线上游戏，从角色扮演到策略对战，太阳娱乐为您精选最值得体验的游戏佳作。',
    content: `
      <p>游戏产业持续蓬勃发展，每年都有大量优秀作品涌现。2026年，多款精品游戏凭借出色的品质和创新的玩法赢得了玩家的广泛好评。太阳娱乐为您精选了本年度最值得体验的游戏作品。</p>
      <h2>角色扮演类游戏</h2>
      <p>角色扮演游戏一直以来都是最受玩家欢迎的游戏类型之一。2026年，多款国产RPG大作凭借精美的画面、丰富的剧情和创新的战斗系统，成功吸引了海量玩家的关注。</p>
      <p>这些游戏不仅在画面表现上达到了国际一流水平，在玩法设计和文化内涵上也展现出了独特的东方美学魅力。太阳娱乐游戏频道为您提供这些游戏的深度评测和攻略指南。</p>
      <h2>策略对战类游戏</h2>
      <p>策略类游戏考验的是玩家的智慧和决策能力。2026年的策略游戏市场呈现出多元化的发展趋势，从传统的即时战略到新兴的自走棋品类，各种创新玩法层出不穷。</p>
      <h2>休闲社交类游戏</h2>
      <p>休闲游戏因其轻松愉快的游戏体验和较低的入门门槛，拥有最广泛的用户群体。2026年，多款休闲社交游戏凭借创新的社交玩法和精美的美术风格，成为了现象级的爆款产品。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20setup%20with%20multiple%20screens%20displaying%20various%20game%20genres%2C%20RGB%20ambient%20lighting%20with%20warm%20golden%20accents%2C%20premium%20gaming%20peripherals%2C%20immersive%20atmosphere%2C%20professional%20product%20photography%20style%20with%20soft%20shadows&width=800&height=450&seq=xianshang-youxi&orientation=landscape',
    category: 'youxi',
    date: '2026-08-03',
    author: '太阳娱乐游戏部',
    readTime: '10分钟',
    views: 15240,
    tags: ['游戏', '推荐', '线上游戏'],
  },
  {
    slug: 'dianying-xinpian-shangying',
    title: '暑期档热门电影推荐：这些大片不容错过',
    excerpt: '2026暑期档电影市场火爆异常，太阳娱乐为您盘点最值得走进影院的精彩大片。',
    content: `
      <p>暑期档历来是电影市场的兵家必争之地。2026年的暑期档更是大片云集，多部制作精良的作品在票房和口碑上都取得了优异的成绩。</p>
      <h2>国产大片强势来袭</h2>
      <p>今年暑期档，国产电影展现出了强劲的竞争力。多部投资过亿的国产大片在特效制作、故事叙述和演员表现上都达到了新的高度，赢得了观众和专业影评人的一致好评。</p>
      <p>其中科幻题材和动画电影表现尤为亮眼，展现了中国电影工业的快速进步和创新能力。</p>
      <h2>进口大片精彩纷呈</h2>
      <p>好莱坞方面也带来了多部重量级作品。从超级英雄系列到经典IP续作，从原创科幻到动画精品，类型丰富多样，满足了不同观众的口味需求。</p>
      <h2>观影指南</h2>
      <p>面对琳琅满目的电影选择，太阳娱乐为您整理了最值得观看的暑期档电影清单，并提供详细的观影指南，帮助您在有限的时间里选择最适合自己的影片。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20premium%20seating%20and%20large%20screen%20displaying%20epic%20film%20scene%2C%20warm%20ambient%20lighting%20with%20gold%20decorative%20elements%2C%20luxurious%20atmosphere%2C%20professional%20cinematography%20composition&width=800&height=450&seq=dianying-xinpian&orientation=landscape',
    category: 'yingshi',
    date: '2026-08-01',
    author: '太阳娱乐编辑部',
    readTime: '5分钟',
    views: 7890,
    tags: ['电影', '暑期档', '推荐'],
  },
  {
    slug: 'yinyue-shengdian-gexing',
    title: '音乐盛典回顾：年度金曲与闪耀舞台的精彩瞬间',
    excerpt: '回顾本年度各大音乐盛典的精彩时刻，盘点年度金曲，感受音乐带来的无限感动。',
    content: `
      <p>音乐是人类共通的语言。2026年的各大音乐盛典为乐迷们带来了无数难忘的瞬间。从流行音乐到古典乐章，从摇滚现场到电子音乐节，音乐的魅力无处不在。</p>
      <h2>年度音乐盛典盘点</h2>
      <p>今年的各大音乐颁奖典礼精彩纷呈。多位实力唱将凭借出色的作品获得了重要奖项，新人也展现出了令人惊喜的才华和潜力。太阳娱乐音乐频道为您详细回顾了这些闪耀时刻。</p>
      <h2>年度金曲推荐</h2>
      <p>2026年诞生了多首脍炙人口的金曲。这些歌曲不仅在各大音乐平台取得了优异的播放数据，更在社交媒体上引发了广泛传播和讨论。太阳娱乐为您精选了年度最具代表性的金曲歌单。</p>
      <h2>音乐产业趋势</h2>
      <p>数字音乐时代，音乐产业的商业模式和消费方式正在发生深刻变革。从流媒体平台到短视频音乐，从虚拟演唱会到AI音乐创作，新技术正在重塑音乐产业的格局。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20dramatic%20golden%20spotlights%20and%20atmospheric%20fog%2C%20elegant%20orchestra%20performance%2C%20warm%20and%20luxurious%20lighting%20design%2C%20professional%20event%20photography%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=yinyue-shengdian&orientation=landscape',
    category: 'yinyue',
    date: '2026-07-30',
    author: '太阳娱乐音乐部',
    readTime: '6分钟',
    views: 6340,
    tags: ['音乐', '演唱会', '金曲'],
  },
];

export const categories = [
  {
    slug: 'dianjing',
    name: '电子竞技',
    icon: 'ri-gamepad-line',
    description: '全球顶级电竞赛事实时追踪，专业解说与深度分析',
    color: 'accent',
  },
  {
    slug: 'yule',
    name: '娱乐资讯',
    icon: 'ri-star-line',
    description: '明星动态、影视热点、综艺节目一站式获取',
    color: 'primary',
  },
  {
    slug: 'tiyu',
    name: '体育赛事',
    icon: 'ri-basketball-line',
    description: 'NBA、五大联赛等全球顶级体育赛事全面覆盖',
    color: 'secondary',
  },
  {
    slug: 'youxi',
    name: '精品游戏',
    icon: 'ri-game-line',
    description: '最新游戏评测、攻略指南与玩家社区互动',
    color: 'accent',
  },
  {
    slug: 'yingshi',
    name: '影视推荐',
    icon: 'ri-movie-2-line',
    description: '院线大片、热门剧集推荐与深度影评分析',
    color: 'primary',
  },
  {
    slug: 'yinyue',
    name: '音乐天地',
    icon: 'ri-music-line',
    description: '年度金曲、音乐盛典与艺人动态精彩呈现',
    color: 'secondary',
  },
];

export const faqData = [
  {
    question: '太阳娱乐平台提供哪些娱乐项目？',
    answer: '太阳娱乐平台提供丰富多样的娱乐项目，包括电子竞技赛事直播、娱乐资讯追踪、体育赛事报道、精品游戏推荐、影视内容点评和音乐资讯等。我们致力于为用户打造一站式的综合娱乐体验。',
  },
  {
    question: '如何在太阳娱乐平台注册账号？',
    answer: '注册太阳娱乐账号非常简单，您只需点击页面右上角的"立即注册"按钮，填写基本信息并完成手机验证，即可成为太阳娱乐的会员，开启您的精彩娱乐之旅。',
  },
  {
    question: '太阳娱乐平台的内容更新频率如何？',
    answer: '太阳娱乐平台保持7×24小时全天候内容更新，我们的专业编辑团队实时追踪全球娱乐资讯，确保您能够在第一时间获取最新、最全面的娱乐内容。',
  },
  {
    question: '太阳娱乐平台是否支持移动端访问？',
    answer: '是的，太阳娱乐平台全面适配移动端设备。您可以通过手机浏览器直接访问我们的网站，获得与桌面端同样流畅、优质的浏览体验。',
  },
  {
    question: '太阳娱乐平台的内容是否免费？',
    answer: '太阳娱乐平台的大部分内容对所有注册用户免费开放。我们也会不定期推出会员专属的精品内容和福利活动，为用户提供更多增值服务。',
  },
  {
    question: '如何联系太阳娱乐的客服团队？',
    answer: '您可以通过平台在线客服、官方邮箱kefu@taiyangyule.com或拨打客服热线400-888-8888与我们取得联系。我们的客服团队7×24小时为您提供专业服务。',
  },
];

export const statsData = [
  { label: '注册用户', value: '5000万+', icon: 'ri-user-star-line' },
  { label: '日均活跃', value: '800万+', icon: 'ri-fire-line' },
  { label: '内容资源', value: '10万+', icon: 'ri-database-2-line' },
  { label: '合作品牌', value: '2000+', icon: 'ri-group-line' },
];